import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Box } from '@mui/material';

// project imports
import config from 'config';

// assets
import LogoImg from 'assets/images/logo.png';

export default function LogoIcon() {
  return (
    <Box
      component={RouterLink}
      to={"/"}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 48,
        width: 48,
        mx: 'auto'
      }}
    >
      <Box
        component="img"
        src={LogoImg}
        alt="Verification Professional"
        sx={{
          height: 22,
          width: 'auto'
        }}
      />
    </Box>
  );
}
